module.exports = __webpack_public_path__ + "assets/img/dave-nosworthy.4cbd40e4.jpg";